// extracted by mini-css-extract-plugin
export var checkboxInputRow = "t_rG";
export var checkboxInputColumn = "t_rH";
export var inputOptionRow = "t_pS";
export var inputOptionColumn = "t_pT";